import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../../utils/api';

interface NotificationState {
  items: any[];
  unreadCount: number;
  isLoading: boolean;
}

const initialState: NotificationState = { items: [], unreadCount: 0, isLoading: false };

export const fetchNotifications = createAsyncThunk('notifications/fetch', async () => {
  const response = await api.get('/notifications');
  return response.data.data;
});

export const markAsRead = createAsyncThunk('notifications/markRead', async (id: string) => {
  await api.put(`/notifications/${id}/read`);
  return id;
});

const notificationSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchNotifications.fulfilled, (state, action) => {
        state.items = action.payload || [];
        state.unreadCount = (action.payload || []).filter((n: any) => !n.is_read).length;
      })
      .addCase(markAsRead.fulfilled, (state, action) => {
        const item = state.items.find(n => n.notification_id === action.payload);
        if (item) { item.is_read = true; state.unreadCount = Math.max(0, state.unreadCount - 1); }
      });
  },
});

export default notificationSlice.reducer;
